/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ prep: NonNullable<unknown>, cook: NonNullable<unknown> }} Recipe_Prep_CookInputs */

const en_recipe_prep_cook = /** @type {(inputs: Recipe_Prep_CookInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.prep} prep, ${i?.cook} cook`)
};

const de_recipe_prep_cook = /** @type {(inputs: Recipe_Prep_CookInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.prep} Vorb., ${i?.cook} Kochen`)
};

/**
* | output |
* | --- |
* | "{prep} prep, {cook} cook" |
*
* @param {Recipe_Prep_CookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_prep_cook = /** @type {((inputs: Recipe_Prep_CookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Prep_CookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_prep_cook(inputs)
	return en_recipe_prep_cook(inputs)
});